import React, { useState, useEffect } from 'react';
import { apiCall } from '../../api';

const StatisticsCards = () => {
  const [stats, setStats] = useState({
    total_users: 0,
    active_users: 0,
    inactive_users: 0,
    suspended_users: 0,
    total_tokens: 0,
    active_tokens: 0,
    inactive_tokens: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      const response = await apiCall('/api-users/statistics');
      setStats(response);
      setError(null);
    } catch (err) {
      console.error('Error fetching statistics:', err);
      setError('Failed to load statistics');
    } finally {
      setLoading(false);
    }
  };

  const StatCard = ({ title, value, color, icon }) => (
    <div className="bg-white rounded-lg shadow p-6 border-l-4" style={{ borderColor: color }}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold" style={{ color }}>{value}</p>
        </div>
        <div className="text-4xl opacity-20">{icon}</div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-gray-200 rounded-lg shadow p-6 animate-pulse">
            <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
            <div className="h-8 bg-gray-300 rounded w-1/3"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
        <p className="text-red-800">{error}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <StatCard
        title="Total API Users"
        value={stats.total_users}
        color="#3B82F6"
        icon="👥"
      />
      <StatCard
        title="Active API Users"
        value={stats.active_users}
        color="#10B981"
        icon="✓"
      />
      <StatCard
        title="Total Tokens"
        value={stats.total_tokens}
        color="#8B5CF6"
        icon="🔑"
      />
      <StatCard
        title="Active Tokens"
        value={stats.active_tokens}
        color="#F59E0B"
        icon="⚡"
      />
    </div>
  );
};

export default StatisticsCards;
